/** @jsxImportSource @emotion/react */
import Typography from '@mui/material/Typography'
import { useCallback } from 'react'
import { BaseModal } from 'components/Modals/BaseModal'
import { CreateQuestionBankCategoryInput } from '__generatedTypes__/globalTypes'
import { SubjectExtended } from 'hooks/usePlatformsAndSubjects'
import { toast } from 'utils/toast'
import { useCategoriesApi } from '../useCategoriesApi'
import { Form } from './Form'
import * as classes from './styles'

export type CreateCategoryModalProps = {
  open: boolean
  subject: SubjectExtended
  defaultOrder: number
  onClose: () => void
  onRefetch: () => void
}

export const CreateCategoryModal = ({
  open,
  subject,
  defaultOrder,
  onClose,
  onRefetch,
  ...props
}: CreateCategoryModalProps) => {
  const categoriesApi = useCategoriesApi()

  const handleSubmit = useCallback(
    async (category: CreateQuestionBankCategoryInput) => {
      try {
        await categoriesApi.createCategory(subject, {
          tabIndex: subject.tabIndex,
          ...category,
        })
        onClose()
        onRefetch()

        toast.success('Category created successfully')
      } catch (e) {
        toast.error('Failed to create category')
      }
    },
    [subject, onClose, onRefetch]
  )

  return (
    <BaseModal open={open} onClose={onClose} {...props}>
      <Typography css={classes.title} variant="title2">
        Create Question Bank Category
      </Typography>
      <Form categoryOrSubjectId={subject.id} defaultOrder={defaultOrder} onSubmit={handleSubmit} onCancel={onClose} />
    </BaseModal>
  )
}
